(function () {

	'use strict';

	/*global $:true, cologic:true */

	// Frontend filter (general category / News category / author / date-from) and sort
	// (headline / date / category) for the "News Crawler" content element (CType
	// "news_crawler"). The filter/sort engine itself is the generic
	// cologic.initCrawlerControls (cologic-crawlerControls.js, shared with the Event Crawler);
	// this only maps NewsCrawler.fluid.html's data-* attribute contract onto it.

	let cologicNewsCrawler = {

		initNewsCrawler: function (rootSelector) {
			cologic.initCrawlerControls(rootSelector, {
				card: '.news-card',
				filterControl: '.news-crawler-filter',
				filterAttribute: 'data-newscrawler-filter',
				sortControl: '.news-crawler-sort',
				grid: '.news-crawler-grid',
				slider: '.news-crawler-slider .slider',
				sliderViewClass: 'news-crawler-view-slider',
				filters: [
					// General/sys_category - options built from whatever actually got crawled.
					{name: 'categories', dataKey: 'categories', match: 'inList', populate: {valueKey: 'categories', labelKey: 'categoryTitles', sort: 'locale'}},
					// News Category - static options (small, well-known vocabulary, rendered with
					// its own translated labels directly in NewsCrawler.fluid.html).
					{name: 'newsCategory', dataKey: 'newsCategory', match: 'equals'},
					{name: 'author', dataKey: 'author', match: 'equals', populate: {valueKey: 'author', sort: 'value'}},
					{name: 'dateFrom', dataKey: 'date', match: 'dateFrom'}
				],
				sorts: {
					date_desc: {dataKey: 'date', type: 'number', dir: 'desc'},
					date_asc: {dataKey: 'date', type: 'number', dir: 'asc'},
					headline_asc: {dataKey: 'headline', type: 'string', dir: 'asc'},
					headline_desc: {dataKey: 'headline', type: 'string', dir: 'desc'},
					category_asc: {dataKey: 'newsCategory', type: 'string', dir: 'asc'},
					category_desc: {dataKey: 'newsCategory', type: 'string', dir: 'desc'}
				},
				defaultSort: 'date_desc'
			});
		}

	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicNewsCrawler);
}());
